import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Image from '../Image'
import moment from 'moment'
import Link from '../Link'
import Markdown from '../Markdown'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const CardContainer = styled.div`
  display: inline-flex;
  flex: 1 0 33.333333%;
  max-width: 33.333333%;
  padding: 1rem;
  min-height: 30rem;

  @media screen and (max-width: 1000px) {
    flex-basis: 50%;
    max-width: 50%;
  }

  @media screen and (max-width: 500px) {
    flex-basis: 100%;
    max-width: 100%;
  }
`

const Card = styled.div`
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.cardBackground};
  flex: 1;
  display: flex;
  flex-direction: column;
`

const Title = styled.div`
  max-width: 100%;
  background-color: ${({ theme }) => theme.colors.cardTitleBackground};

  > a {
    display: flex;

    img {
      width: 6rem;
      margin: 0;
    }

    > div:first-of-type {
      width: 6rem;
      height: 6rem;
    }

    > div:last-of-type {
      flex: 1;
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 0.5rem 1rem;
    }

    h4,
    small {
      margin: 0;
      line-height: normal;
    }

    img {
      margin: 0;
      display: block;
    }
  }
`

const Body = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex: 1;

  small {
    margin-top: auto;
  }
`

// Added a filter for a hacky solution to not show articles which don't have a translation... The articles array
// (without modifying node logic) has an undefined item for any article who's translation for the current lang is
// not present. .filter(a => a)

const Articles = ({ articles }) => (
  <Container>
    {articles
      .filter((a) => a)
      .map((article) => (
        <CardContainer key={`${article.content.href}_${article.content.title}`}>
          <Card>
            <Title>
              <Link
                tracking={{ label: 'press_article_title' }}
                href={article.content.href}
              >
                <div>
                  <Image
                    src={article.thumbnail}
                    alt={article.publisher}
                    size={60}
                  />
                </div>
                <div>
                  <h4 title={article.publisher}>{article.publisher}</h4>
                  <small>
                    <strong>{moment(article.publish_date).format('LL')}</strong>
                  </small>
                </div>
              </Link>
            </Title>
            <Body>
              <Markdown source={article.content.title} />
              {article.author && (
                <small>
                  <em>{article.author}</em>
                </small>
              )}
            </Body>
          </Card>
        </CardContainer>
      ))}
  </Container>
)

Articles.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      thumbnail: PropTypes.string.isRequired,
      publisher: PropTypes.string.isRequired,
      publish_date: PropTypes.string.isRequired,
      author: PropTypes.string,
      content: PropTypes.shape({
        title: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired
      }).isRequired
    })
  )
}

export default Articles
